//const API_BASE_URL = "https://localhost:443/api";
const API_BASE_URL = "https://api.tripsplitter.fyi/api";
export default API_BASE_URL;
